'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var style = {"PageCanvasContainer":"PageCanvas-module_PageCanvasContainer__hcBq0","PageCanvasMenu":"PageCanvas-module_PageCanvasMenu__HS2zR","PageCanvasContent":"PageCanvas-module_PageCanvasContent__3Bu-j"};

exports["default"] = style;
